import React from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

function LastUpdatedTimestamp({ timestamp = null }) {
    const theme = useTheme();

    return (
        <Typography variant="caption" color={theme.palette.subtext.main}>
            {(() => {
                if (!timestamp) return null;
                const date = new Date(timestamp);
                if (isNaN(date.getTime())) return null;
                const now = new Date();
                const diffMs = now - date;
                const diffSec = diffMs / 1000;
                const diffMin = diffSec / 60;
                const diffHr = diffMin / 60;
                if (diffHr >= 1) {
                    return `Last updated ${Math.floor(diffHr)} hour${Math.floor(diffHr) === 1 ? '' : 's'} ago`;
                } else if (diffMin >= 1) {
                    return `Last updated ${Math.floor(diffMin)} minute${Math.floor(diffMin) === 1 ? '' : 's'} ago`;
                } else if (diffMs < 0) {
                    return null; // Future date, shouldn't happen
                } else {
                    return 'Last updated just now';
                }
            })()}
        </Typography>
    );
}

export default LastUpdatedTimestamp;